"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const alert_1 = __importDefault(require("../../components/alert"));
const pagination_utils_1 = require("../utils/pagination-utils");
const global_search_1 = __importDefault(require("./global-search"));
exports.GlobalSearch = global_search_1.default;
const popover_filter_1 = __importDefault(require("./popover-filter"));
exports.PopoverFilter = popover_filter_1.default;
const filter_unit_1 = __importDefault(require("./filter-unit"));
exports.FilterUnit = filter_unit_1.default;
const loader_1 = __importDefault(require("./loader"));
exports.Loader = loader_1.default;
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
exports.NoRow = (props) => {
    if (props.n > 0) {
        return null;
    }
    return react_1.default.createElement(alert_1.default, { type: "warning" }, "No rows found");
};
exports.PaginationWrapper = (props) => {
    return (react_1.default.createElement("nav", null,
        react_1.default.createElement("ul", { className: "pagination" }, props.children)));
};
exports.PaginationUnit = (props) => {
    const { isActive, isDisabled, children, onClick } = props;
    // here we disable the button in case it is not valid
    if (isDisabled) {
        return null;
    }
    const className = 'page-item' + (isActive ? ' active' : '') + (isDisabled ? ' disabled' : '');
    return (react_1.default.createElement("li", { className: className },
        react_1.default.createElement("button", { className: "page-link", onClick: onClick }, children)));
};
exports.ColCell = (props) => {
    const { children, colSpan, style } = props;
    return (react_1.default.createElement(core_1.TableCell, { colSpan: colSpan, style: style }, children));
};
exports.HeaderUnit = (props) => {
    const { children } = props;
    return react_1.default.createElement(core_1.TableCell, { style: { fontWeight: 'bold' } }, children);
};
exports.OrderControllerUpAndDown = (props) => {
    return (react_1.default.createElement("span", null,
        react_1.default.createElement("span", { key: 'asc', onClick: () => props.onClick(true) },
            react_1.default.createElement(icons_1.KeyboardArrowUp, null)),
        react_1.default.createElement("span", { key: 'desc', onClick: () => props.onClick(false) },
            react_1.default.createElement(icons_1.KeyboardArrowDown, null))));
};
exports.OrderController = (props) => {
    const { onClick, descAsc } = props;
    let Icon = icons_1.UnfoldMore;
    if (descAsc !== null) {
        Icon = descAsc ? icons_1.KeyboardArrowUp : icons_1.KeyboardArrowDown;
    }
    return (react_1.default.createElement("div", { style: {
            cursor: 'pointer',
            display: 'inline-block',
            color: descAsc === null ? '#ccc' : '#000'
        }, onClick: () => onClick(null) },
        react_1.default.createElement(Icon, null)));
};
exports.ListWrapper = (props) => {
    const { children } = props;
    return react_1.default.createElement("div", { className: "table-responsive-sm" }, children);
};
exports.ListContainer = (props) => {
    const { children, maxHeight, stickyHeader = false } = props;
    return (react_1.default.createElement(core_1.TableContainer, { style: maxHeight ? { maxHeight } : undefined },
        react_1.default.createElement(core_1.Table, { size: "small", stickyHeader: stickyHeader }, children)));
};
exports.Row = (props) => {
    const { children } = props;
    return react_1.default.createElement(core_1.TableRow, null, children);
};
exports.ListHeader = (props) => {
    const { children } = props;
    return react_1.default.createElement(core_1.TableHead, null, children);
};
exports.ListBody = (props) => {
    const { children } = props;
    return react_1.default.createElement(core_1.TableBody, null, children);
};
exports.RecordInfo = (props) => {
    const { nPerPage, idx, n } = props;
    if (n === 0) {
        return null;
    }
    const { start, end } = pagination_utils_1.paginationBoundaries(idx, nPerPage);
    return (react_1.default.createElement("p", { className: "pull-right" },
        "Showing ",
        start + 1,
        " to ",
        Number(start) + Number(nPerPage) > n ? n : end,
        " of",
        ' ',
        n,
        " entries"));
};
